export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--9-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--9-3!../../../node_modules/sass-loader/lib/loader.js??ref--9-4!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register.vue?vue&type=style&index=0&id=2affbb54&prod&lang=scss&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/account/register.vue?vue&type=style&index=0&id=2affbb54&prod&lang=scss&scoped=true
// module id = Gc0S
// module chunks = 1